// src/pages/Dashboard.jsx
import React, { useState } from 'react';
import Sidebar from '../envelope/Sidebar'
import TopBar from '../envelope/TopBar'
import './Dashboard.css'

const Dashboard = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      
      <TopBar isCollapsed={isSidebarCollapsed} />  

      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="welcome-container">
          <h1>Привет!</h1>
          <p>Вы успешно авторизовались в системе социометрии</p>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;